import { render, staticRenderFns } from "./CalendarsCreateEdit.vue?vue&type=template&id=367902b7"
import script from "./CalendarsCreateEdit.vue?vue&type=script&lang=js"
export * from "./CalendarsCreateEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports